import { Component, OnInit, Input, ViewChild  } from '@angular/core';
import { AuthenticationService, UtilsService, CatalogService, UserService, ListsService } from '../../_services';
import { User, ScheduleDelivery, ListUserAddress, DeliveryReservation, Delivery, ScheduleDeliveries, PickUpCenter } from '../../_models';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BasketService } from 'src/app/_services/basket.service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { ApplicationStateService } from 'src/app/_services/application-state.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { LoginAxaErrorModalComponent } from 'src/app/login-axa-error-modal/login-axa-error-modal.component';
import { MessageModalComponent } from 'src/app/message-modal/message-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { error } from 'protractor';
import { of } from 'rxjs';
import { concatMap, concat, tap, catchError, delay } from 'rxjs/operators';

declare const $ : any;

@Component({
  selector: 'app-userbar',
  templateUrl: './userbar.component.html',
  styleUrls: ['./userbar.component.css']
})

export class UserbarComponent implements OnInit {
  
  public searchForm: FormGroup;
  public orderPlanForm: FormGroup;
  public plannedOrder : boolean;

  public currentUser: User;
  private scheduleDeliveries : ScheduleDeliveries;
  public scheduleHours : ScheduleDelivery[];
  public userAddresses : ListUserAddress[];
  public selectedHourRange : number;
  public submited : boolean;
  public delivery : Delivery;
  @Input() sticky : string;

  public inCheckOut: boolean;

  @ViewChild(MessageModalComponent) messageModal: MessageModalComponent;
  @ViewChild(LoginAxaErrorModalComponent) axaErrorModal: LoginAxaErrorModalComponent;
  constructor(
    public auth: AuthenticationService,
    public formBuilder: FormBuilder,
    public translate: TranslateService,
    public catalog : CatalogService,
    public basket : BasketService,
    public router : Router,
    public utils : UtilsService,
    public datePipe : DatePipe,
    public apps : ApplicationStateService,
    public users : UserService,
    public listss : ListsService
  ) {
  }


  ngOnInit() {

    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
      $('[data-toggle="tooltip"]').tooltip('dispose');
    }, environment.READY_TIMEOUT);
   
    // search
    this.searchForm = this.formBuilder.group({
      searchText: ['']  
    });

    // orderPlan
    this.orderPlanForm = this.formBuilder.group({
      sendTo :['address'],
      recid : [ , Validators.required],
      centerid: [ , Validators.required],
      date: ['', Validators.required],
      hourRange: ['', Validators.required]
    });  

    this.submited = false;

    this.auth.currentUser.subscribe( user => {
      this.currentUser = user;
      
      if (this.currentUser) {

       this.setLanguage(this.currentUser.language);

        //Devolver sólo direcciones de entrega
        this.userAddresses = this.currentUser.user_addresses.filter( address => {
          return address.address_type == 2 && (address.centre_ClickRecull == '' || address.centre_ClickRecull == null)
        });

        if (this.userAddresses.length > 0){
          this.f.sendTo.setValue('address');
        } else {
          this.f.sendTo.setValue('center');
        }

        let primaryAddress = this.currentUser.primaryAddress;

        if (!primaryAddress){
          this.f.recid.setValue('');
          this.f.centerid.setValue('');
        } else {
          if (! primaryAddress.centre_ClickRecull || primaryAddress.centre_ClickRecull.trim() == ''  ){
            this.f.sendTo.setValue('address');
            this.f.recid.setValue(primaryAddress.recid.trim());
            this.f.centerid.setValue('');
          } else {
            this.f.sendTo.setValue('center');          
            this.f.centerid.setValue(primaryAddress.centre_ClickRecull.trim());                     
            this.f.recid.setValue('');
          }  
        }
      }
    });

    this.basket.delivery.subscribe( result => {
      this.delivery = result;
      this.refreshDelivery();
    });
  

    this.basket.inCheckOut.subscribe(checkOut => {
      if (! checkOut && this.inCheckOut){
        this.setDatePicker();
      }
      this.inCheckOut = checkOut;
    });

  }


  ngAfterViewInit(){
    // this.setDatePicker();

    // $('.planifica-comanda a.dropdown-toggle, .planifica-comanda-icon').on('click', (e : any) => {
    //   if (location.pathname == '/user/cart'){
    //       setTimeout(() => {
    //         $('.datepicker').datepicker('destroy');
    //         $('.datepicker').datepicker({
    //             autoclose: true,
    //             language: this.translate.currentLang ,
    //             keyboardNavigation : false,
    //             forceParse: false,
    //             beforeShowDay : (sDate : Date ) => { return this.isAvailableDate(sDate); }
    //         })
    //         .on('changeDate', (e : any ) => { this.onChangeDate(e); }); 
    //       }, environment.READY_TIMEOUT);
    //   }
    // });
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    this.setDatePicker();
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
      $('[data-toggle="tooltip"]').tooltip('dispose');
    }, environment.READY_TIMEOUT);
  }

  setDatePicker(){
    setTimeout(() => {
      $('.datepicker').datepicker('destroy');
      $('.datepicker').datepicker({
          autoclose: true,
          language: this.translate.currentLang ,
          keyboardNavigation : false,
          forceParse: false,
          beforeShowDay : (sDate : Date ) => { return this.isAvailableDate(sDate); }
      })
      .on('changeDate', (e : any ) => { this.onChangeDate(e); }); 
    }, environment.READY_TIMEOUT);   
   
  }

  setDate(date : string, delivery? : Delivery ){
    let range : string = '';

    if (delivery){
      date = delivery.transdate;    
    }
    
    this.f.date.setValue(date, {onlySelf:true,  emitEvent : false});

    if (this.scheduleDeliveries) {
      this.scheduleHours = this.scheduleDeliveries.hours(date);
    } else {
      this.scheduleHours = null;
    }

    if (delivery){
      range = this.scheduleHours.indexOf(this.scheduleHours.find(schedule => {
        return schedule.fromtime == delivery.fromtime && schedule.totime == delivery.totime;
      })).toString();
      this.f.hourRange.setValue(range, {onlySelf:true,  emitEvent : false});
    }
    
  }

  getLanguage() : string{
    return this.translate.currentLang;
  }
  
  // getDeliveryStatus(){
  
  //   this.basket.getDeliveryStatus().subscribe(
  //     result =>{
  //       this.plannedOrder = parseInt(result) ?  true : false;
  //       if (this.plannedOrder){
  //         this.basket.getDeliveryInfo().subscribe(delivery => {
  //           delivery.tipo == 1 ? this.f.sendTo.setValue('address') : this.f.sendTo.setValue('center');
  //           delivery.tipo == 1 ? this.f.recid.setValue(delivery.id_tipo) : this.f.centerid.setValue(delivery.id_tipo);
  //           this.f.date.setValue(result.transdate);
  //           this.refreshDeliverySchedule(delivery)
  //           });
  //       } else {
  //         this.f.recid.setValue(this.currentUser.primaryAddress.recid.trim() );
  //         this.f.centerid.setValue(this.currentUser.primaryAddress.centre_ClickRecull.trim() );  
  //         this.refreshDeliverySchedule();
  //       }
  //   });
  // }

  // search
  onSubmit(){
    // if (this.sticky){
    //   $('#searchResponsive-sticky').collapse('hide');
    // } else {
    //   $('#searchResponsive-').collapse('hide');
    // }
    
      $('#searchResponsive-sticky').collapse('hide');
    
      $('#searchResponsive-').collapse('hide');
    
    const re  = /[àáèéìíòóùúçñÀÁÈÉÌÍÒÓÙÚÇÑ'-_\w\s]+/gi;
    const search = this.searchForm.controls.searchText.value.trim().match(re);
    if (search) {
      const query = search.join(' ').trim();
      this.router.navigate(['/search'], {  queryParams: { q : query }});
    }
    this.searchForm.controls.searchText.setValue(''); 
  }
 
  // order plan
  get f() {
    return this.orderPlanForm.controls;
  }

  onChange() {
    this.setDate('');
    this.refreshDeliverySchedule();
  }

  onChangeDate(e? : any){
    if (e){
      this.setDate(this.datePipe.transform(e.date,"dd/MM/yyyy"));
    } else {
      this.setDate(this.f.date.value);
    }  
  }

 async onSaveReservation(){
    this.submited = true;
    const allSet : boolean =  this.f.sendTo.value && (this.f.centerid.value || this.f.recid.value)  && this.f.date.value &&  this.f.hourRange.value;
    if (allSet){
      let reservation : DeliveryReservation = new DeliveryReservation();

      reservation.tipo = this.f.sendTo.value == 'address' ? 1 : 2;;
      reservation.id_tipo =  this.f.sendTo.value == 'address' ? this.f.recid.value : this.f.centerid.value;
      reservation.transdate = this.f.date.value;
      reservation.fromtime =  this.scheduleHours[this.f.hourRange.value].fromtime;
      reservation.totime = this.scheduleHours[this.f.hourRange.value].totime;
      reservation.observacions = '';
      reservation.tiporecogida = this.f.sendTo.value == 'address' ? 0 : +this.utils.pickupCenters.find((p) => p.centerid.trim() === this.f.centerid.value ).TipoRecogida ;

      this.basket.setDelivery(reservation).subscribe( 
        async result => {
          this.basket.total().subscribe();
          $('#modal-planifica').modal('hide');
          $('.planifica-comanda .dropdown-menu').removeClass('show');
          
          const errorMessages = await this.limpiarCesta(this.auth.isAxA, false);
          //console.log("helow",errorMessages);
          if (errorMessages) {
            this.axaErrorModal.show(
              this.translate.instant(`BUYAXA.DELIVERY_ERROR`),
              errorMessages
            );

            this.axaErrorModal.close.subscribe(result => {
              //console.log(result);
              if (result) {
                this.limpiarCesta(this.auth.isAxA, true);
              } 
              this.router.navigate(['/user/cart/']);

            });
          }
            this.submited = false;
        },
        error =>{
        }
      );
   }


   //await new Promise(resolve => setTimeout(resolve, 1000));
   
   const errorMessages = await this.limpiarCesta(this.auth.isAxA, false);
   //console.log("helow",errorMessages);
   if (errorMessages) {
     this.axaErrorModal.show(
       this.translate.instant(`BUYAXA.DELIVERY_ERROR`),
       errorMessages
     );

     this.axaErrorModal.close.subscribe(result => {
       //console.log(result);
       if (result) {
         this.limpiarCesta(this.auth.isAxA, true);
       } else {
         this.router.navigate(['/']);
       }
       
     });
   }


  }

  //No se usa. Ahora va en el boton Desar (onSaveReservation)
  // onChangeTime(){   
  //   const allSet : boolean =  this.f.sendTo.value && (this.f.centerid.value || this.f.recid.value)  && this.f.date.value &&  this.f.hourRange.value;
  //   if (allSet){
  //     let reservation : DeliveryReservation = new DeliveryReservation();

  //     reservation.tipo = this.f.sendTo.value == 'address' ? 1 : 2;;
  //     reservation.id_tipo =  this.f.sendTo.value == 'address' ? this.f.recid.value : this.f.centerid.value;
  //     reservation.transdate = this.f.date.value;
  //     reservation.fromtime =  this.scheduleHours[this.f.hourRange.value].fromtime;
  //     reservation.totime = this.scheduleHours[this.f.hourRange.value].totime;

  //     this.basket.setDelivery(reservation).subscribe( 
  //     result => {
  //       this.getDeliveryStatus();
  //     },
  //     error =>{
  //       this.getDeliveryStatus();
  //     });
     
  //   }
  // }

  refreshDelivery(){
    this.plannedOrder = this.delivery == null ? false : true;
    if (this.plannedOrder){
      this.delivery.tipo == 1 ? this.f.sendTo.setValue('address', {onlySelf:true,  emitEvent : false}) : this.f.sendTo.setValue('center',{onlySelf:true,  emitEvent : false});
      this.delivery.tipo == 1 ? this.f.recid.setValue(this.delivery.id_tipo, {onlySelf:true,  emitEvent : false}) : this.f.centerid.setValue(this.delivery.id_tipo, {onlySelf:true,  emitEvent : false});
    }
    this.refreshDeliverySchedule(this.delivery);
  }

  refreshDeliverySchedule(delivery?: Delivery) {

    let deliveryType: number = this.f.sendTo.value == 'address' ? 1 : 2;
    let deliveryId: number = this.f.sendTo.value == 'address' ? this.f.recid.value : this.f.centerid.value;
    let pickupCenter = this.utils.pickupCenters.find((p) => p.centerid.trim() === deliveryId.toString());
    let tiporecogida: number = this.f.sendTo.value == 'address' ? 0 : (pickupCenter ? +pickupCenter.TipoRecogida : 0);
    if (deliveryId && deliveryId != 0) {


      //20250602 axa inici
      if (this.auth.isAxA) {
        if (delivery) {
          this.f.date.setValue(delivery.transdate, { onlySelf: true, emitEvent: false });
          this.f.hourRange.setValue(1, { onlySelf: true, emitEvent: false });
        }
      } else {
        //20250602 axa final

        this.basket.getAvailableSchedule(deliveryType, deliveryId, tiporecogida).subscribe(result => {
          this.scheduleDeliveries = result;
         // console.log("DeliverySchedule-userbar", delivery)
          if (delivery) {
            // Si tenim comanda, resetejem el datepicker perque agafi els dies disponibles segons la data.
            this.setDatePicker();

            let found: boolean = false;
            this.f.date.setValue(delivery.transdate, { onlySelf: true, emitEvent: false });

            if (this.scheduleDeliveries) {
              this.scheduleHours = this.scheduleDeliveries.hours(delivery.transdate);
            } else {
              this.scheduleHours = null;
            }

            if (this.scheduleHours) {
              this.scheduleHours.forEach((sched, ind) => {
                if (delivery.fromtime === sched.fromtime) {
                  found = true;
                }
              });

              // Si ya no esta disponible el horario, lo añade (pués esta planificado)
              if (!found) {
                let schedule: ScheduleDelivery = new ScheduleDelivery();
                schedule.fromtime = delivery.fromtime;
                schedule.totime = delivery.totime;
                schedule.transdate = delivery.transdate;
                schedule.id_tipo = delivery.id_tipo;
                this.scheduleHours.push(schedule);

                this.scheduleHours.sort((a, b) => {
                  return a.fromtime.localeCompare(b.fromtime);
                })
              }

              this.scheduleHours.forEach((sched, ind) => {
                if (delivery.fromtime === sched.fromtime) {
                  this.selectedHourRange = ind;
                  this.f.hourRange.setValue(ind, { onlySelf: true, emitEvent: false });
                }
              });
            }

          } else {
            $('.datepicker').datepicker('update', '');
            this.f.date.setValue('', { onlySelf: true, emitEvent: false });
            this.f.hourRange.setValue('', { onlySelf: true, emitEvent: false });
          }
        },
          error => {           
            this.scheduleDeliveries = null;
            $('.datepicker').datepicker('update', '');
            this.setDate('');
          }
        );
        //20250602 axa inici
      }
      //20250602 axa final
    } else {
      this.scheduleDeliveries = null;
      $('.datepicker').datepicker('update', '');
      this.setDate('');
    }

   
  }


  async limpiarCesta(isAxA: boolean, isSilenceCorrection: boolean) {
    //console.log("Antes de SilenceCleanBasket");

    try {
      const res = await this.basket.SilenceCleanBasket(isAxA, isSilenceCorrection).toPromise();
    //  console.log("Después de SilenceCleanBasket", res);

      if (isSilenceCorrection) {
      //  console.log("Corrección silenciosa iniciada");

        of(null).pipe(
          tap(() => console.log('get')),
          concatMap(() => this.basket.get()),

          tap(() => console.log('getdelivery')),
          concatMap(() => this.basket.getDelivery()),

          tap(() => console.log('totals')),
          concatMap(() => this.basket.total())
        ).subscribe({
          next: (result) => console.log('resultat parcial', result),
          error: (err) => console.error('error!', err),
          complete: () => console.log('Totes les operacions completades'),
        });
      }

      return res;

    } catch (err) {
      console.error("Error SilenceCleanBasket", err);

      if (err instanceof HttpErrorResponse) {
        console.error('Error al limpiar la cesta', err.status, err.error);
        return err.error;
      }

      if (err && err.error && err.length > 0) {
        // el backend manda [{ conflict_message: "..."}]
        return err.error;
      }

      throw err; // cualquier otro error inesperado
    }
  }



 isAvailableDate(sDate : Date) {

    if (!this.scheduleDeliveries){
      return false;
    }
    
    if ( this.scheduleDeliveries.contains(this.datePipe.transform(sDate,'dd/MM/yyyy'))){
      return { enabled : true, classes : 'available'};
    }
    
    return {enabled : false };

  }

  
  logout() {
    return this.auth.logout().subscribe();
  }

  onConfirmEmpty(event : any){
    this.basket.empty().subscribe();
  }

  //20250602 axa inici
  showModalInfoAxA() {
    $('#modal-infoAxA').modal('show');
  }

  showModalInfoAxa2() {
    $('#modal-infoAxa2').modal('show');
  }
  //20250602 axa final

}

